import { AppResource } from 'src/app/app.resource';
import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { WebCallbackComponent } from 'src/app/shared/components/web-callback/web-callback.component';
import { ResumeStepComponent } from 'src/app/shared/components/resume-step/resume-step.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AdvisorJourneyBannerComponent } from 'src/app/shared/components/advisor-journey-banner/advisor-journey-banner.component';
import { CANAL_VENTE_C } from 'src/app/shared/constants/context.constants';
import { OFFER_CUSTOMIZE_PATH, SUBSCRIPTION_PATH } from 'src/app/shared/constants/route.constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  imports: [
    CommonModule,
    AdvisorJourneyBannerComponent,
    BreadcrumbComponent,
    FooterComponent,
    HeaderComponent,
    WebCallbackComponent,
    RouterModule,
    ResumeStepComponent
  ],
  standalone: true
})
export class AppLayoutComponent extends BaseComponent implements OnInit {
  demo: boolean = false;
  private readonly currentUrl = signal(this.router.url);
  private readonly subscription = this.sharedDataService.getSubscription();

  readonly showAdvisorJourneyBanner = computed(() => {
    if (this.store.context().canalVente !== CANAL_VENTE_C) return false;

    const currentStepPath = this.getCurrentStepPath(this.currentUrl());
    const subscription = this.subscription();
    if (!currentStepPath || !subscription) return false;

    const orderedStepPaths = subscription.groupSteps.flatMap(groupStep =>
      groupStep.steps.map(step => step.url)
    );
    const currentStepIndex = orderedStepPaths.indexOf(currentStepPath);
    const offerCustomizeIndex = orderedStepPaths.indexOf(OFFER_CUSTOMIZE_PATH);

    return currentStepIndex >= 0 && offerCustomizeIndex >= 0 && currentStepIndex < offerCustomizeIndex;
  });

  constructor(
    resources: AppResource,
    private readonly router: Router,
    private readonly sharedDataService: SharedDataService
  ) {
    super(resources);
  }

  override ngOnInit() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(event => this.currentUrl.set(event.urlAfterRedirects));
  }

  private getCurrentStepPath(url: string): string | undefined {
    const segments = this.router.parseUrl(url).root.children['primary']?.segments.map(segment => segment.path) ?? [];
    const subscriptionIndex = segments.indexOf(SUBSCRIPTION_PATH);

    return subscriptionIndex >= 0 ? segments[subscriptionIndex + 1] : undefined;
  }
}
